import { UserNotifications } from '../interfaces';

export const DefaultUserNotifications = () => ({
	email: true,
});

export const createUserNotification = (): UserNotifications =>
	DefaultUserNotifications();
